package kotlinx.html

import kotlinx.html.*
import kotlinx.html.impl.*
import kotlinx.html.attributes.*

/*******************************************************************************
    DO NOT EDIT
    This file was generated by module generate
*******************************************************************************/

@Suppress("unused")
open class NAV(initialAttributes : Map<String, String>, override val consumer : TagConsumer<*>) : HTMLTag("nav", consumer, initialAttributes, null, false, false), CommonAttributeGroupFacadeFlowSectioningContent {

}
val NAV.asFlowContent : FlowContent
    get()  = this

val NAV.asSectioningContent : SectioningContent
    get()  = this


@Suppress("unused")
open class NOSCRIPT(initialAttributes : Map<String, String>, override val consumer : TagConsumer<*>) : HTMLTag("noscript", consumer, initialAttributes, null, false, false), CommonAttributeGroupFacadeFlowMetaDataPhrasingContent {

}
val NOSCRIPT.asFlowContent : FlowContent
    get()  = this

val NOSCRIPT.asMetaDataContent : MetaDataContent
    get()  = this

val NOSCRIPT.asPhrasingContent : PhrasingContent
    get()  = this


